'use client';

import Divider from '@/ui/divider/divider';

// import { useEffect } from 'react';
// import { useIsMounted } from 'usehooks-ts';
//
// import { useRouter } from '@/i18n/routing';
import styles from './item-not-found.module.scss';

interface ListingNotFoundProps {
  text: string,
}

export default function ItemNotFound(props: ListingNotFoundProps) {
  const { text } = props;

  // const router = useRouter();
  // const isMounted = useIsMounted();

  // useEffect(() => {
  //   setTimeout(() => {
  //     router.push('/');
  //   }, 2000);
  // }, [isMounted, router]);

  return (
    <div className={styles.itemNotFound}>
      <p className={styles.itemNotFound_text}>
        {text}
      </p>
      <Divider />
    </div>
  );
}
